/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import AdCaller from 'helpers/ads/adCaller';
import TileWidget from './TopicTile';
import s from './TopicTileWrapper.scss';
// import Listingheader from '../../../../home/components/common/ListingheaderV2';

class TopicTileWrapper extends React.Component {
  render() {
    const {
      allepisodes,
      loadMoreNews,
      hideNewsMoreButton,
      isLoadingNewsData,
      selectedTab,
      headingName,
      frmNoResultTopStories,
      isPrime,
      getLeaderboardAds,
    } = this.props;
    let showLoadMoreBeforeAd = false;

    return allepisodes &&
      Array.isArray(allepisodes) &&
      allepisodes.length > 0 ? (
      <div className="tabs_common">
        {headingName && <h2 className={s.heading}>{headingName} </h2>}
        <div className={s.all}>
          {/* <div className={s.top_stories_wrap}>
      <div className={s.heading}>
        Top Stories from <i />
      </div>
      <div className={s.top_stories}>
        <div className={s.toiplus_top}>
          <div className={s.stoires_block}>
            <div className={s.cards_box}>Card 1</div>
            <div className={s.cards_box}>Card 1</div>
            <div className={s.cards_box}>Card 1</div>
          </div>
        </div>
        <div className={s.top_rhs_ad}>
          <div>AD stoires_block</div>
        </div>
      </div>
    </div> */}

          <div className={s.article_list_block}>
            <div className={s.lists}>
              {allepisodes &&
                allepisodes.map((item, index) => {
                  const leaderboardAd = getLeaderboardAds(index, selectedTab);
                  if (allepisodes.length === index + 1 && leaderboardAd) {
                    showLoadMoreBeforeAd = true;
                  }
                  return (
                    <>
                      <TileWidget
                        data={item}
                        theme={this.props.theme}
                        newga={`Search_Result${
                          selectedTab ? `-${selectedTab}` : ``
                        }#${
                          frmNoResultTopStories
                            ? `View_No_Result_Page_Content-`
                            : `View_Content-`
                        }Open_Content-${index + 1}`}
                        indexVal={index}
                        wrapperClassName={this.props.wrapperClassName}
                        isFeatureshow={this.props.isFeatureshow}
                      />
                      {!hideNewsMoreButton &&
                        showLoadMoreBeforeAd && (
                          <div
                            className={`${s.loadMore} ${
                              isLoadingNewsData ? s.loader : ''
                            }`}
                          >
                            <button type="button" onClick={loadMoreNews}>
                              Load More Articles
                            </button>
                          </div>
                        )}
                      {!isPrime &&
                        leaderboardAd &&
                        (index + 1) % 5 === 0 && (
                          <div className="leaderboardAd">
                            <div className="lbAdplaceholder">
                              <AdCaller
                                skipReRender
                                data={{
                                  name: 'mid1',
                                  ...leaderboardAd,
                                }}
                                immediateLoad
                              />
                            </div>
                          </div>
                        )}
                    </>
                  );
                })}
            </div>
          </div>
          {!hideNewsMoreButton &&
            !showLoadMoreBeforeAd && (
              <div
                className={`${s.loadMore} ${isLoadingNewsData ? s.loader : ''}`}
              >
                <button type="button" onClick={loadMoreNews}>
                  Load More Articles
                </button>
              </div>
            )}
        </div>
      </div>
    ) : null;
  }
}

TopicTileWrapper.propTypes = {
  allepisodes: PropTypes.arrayOf(PropTypes.shape({})),
  theme: PropTypes.string,
  headingName: PropTypes.string,
  frmNoResultTopStories: PropTypes.bool,
  isPrime: PropTypes.bool,
  getLeaderboardAds: PropTypes.func,
};
TopicTileWrapper.defaultProps = {
  allepisodes: [],
  theme: '',
  headingName: undefined,
  frmNoResultTopStories: false,
  isPrime: false,
  getLeaderboardAds: () => {},
};

export default TopicTileWrapper;
